<template>
  <div class="daily-trend-container">
    <div
      v-if="!loadingRuntimeGraph"
      class="dt-sub-container"
    >
      <div class="filter-container">
        <div class="dt-filter-option">
          <div>Filters: </div>
          <CycleSystemFilter />
        </div>
      </div>
      <div class="graphs-container">
        <DailyDeltaTGraph
          :dailyStats="runtimeGraphData"
          :reverse="reverseXaxis"
        />
        <DailyDeltaPGraph
          :dailyStats="runtimeGraphData"
          :pressureConversion="pressureConversion"
          :reverse="reverseXaxis"
        />
        <DailyCycleTimeGraph
          :dailyStats="runtimeGraphData"
          :reverse="reverseXaxis"
        />
        <DailySupplyAirGraph
          :dailyStats="runtimeGraphData"
          :reverse="reverseXaxis"
        />
        <RuntimeGraph
          :runtimeGraphData="runtimeGraphData"
          :reverse="reverseXaxis"
        />
        <FilterLifeGraph
          :dailyStats="runtimeGraphData"
          :reverse="reverseXaxis"
        />
        <HumidityGraph v-if="isA2SensorTempExist" />
        <RoomTempGraph v-if="isA2RoomSensorExist" />
      </div>
    </div>
    <div
      v-else
      class="loading-container"
    >
      <img
        src="@shared/assets/img/general/loading.svg"
        alt="loading"
      >
    </div>
  </div>
</template>

<script>
import CycleSystemFilter from '@shared/components/customerDetail/CycleSystemFilter.vue';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import RuntimeGraph from '@shared/components/customerDetail/dailyTrendsGraphs/RuntimeGraph.vue';
import DailyDeltaTGraph from '@shared/components/customerDetail/dailyTrendsGraphs/DailyDeltaTGraph.vue';
import DailyDeltaPGraph from '@shared/components/customerDetail/dailyTrendsGraphs/DailyDeltaPGraph.vue';
import DailyCycleTimeGraph from '@shared/components/customerDetail/dailyTrendsGraphs/DailyCycleTimeGraph.vue';
import DailySupplyAirGraph from '@shared/components/customerDetail/dailyTrendsGraphs/DailySupplyAirGraph.vue';
import FilterLifeGraph from '@shared/components/customerDetail/dailyTrendsGraphs/FilterLifeGraph.vue';
import HumidityGraph from './dailyTrendsGraphs/HumidityGraph.vue';
import RoomTempGraph from './dailyTrendsGraphs/RoomTempGraph.vue';

export default {
  name: 'DailyTrends',
  components: {
    CycleSystemFilter,
    FilterLifeGraph,
    DailySupplyAirGraph,
    DailyCycleTimeGraph,
    DailyDeltaPGraph,
    DailyDeltaTGraph,
    RuntimeGraph,
    HumidityGraph,
    RoomTempGraph,
  },
  mixins: [customerDetailMixin],
  data() {
    const timescale = [{
      value: 7,
      key: '7 Days',
    }, {
      value: 30,
      key: '30 Days',
    }, {
      value: 60,
      key: '60 Days',
    }, {
      value: 90,
      key: '90 Days',
    }];
    return {
      timescale,
    };
  },
  computed: {
    reverseXaxis() {
      return this.runtimeGraphData.length === 0;
    },
  },
  mounted() {
    if (this.cycleFilter.uId === '') {
      this.handleFilter('dId', this.supplySensors[0].dId);
      this.handleFilter('uId', this.supplySensors[0].uId);
      this.handleFilter('location', this.supplySensors[0].location);
      this.getRuntimeGraph('zones', this.supplySensors);
    }
  },
  methods: {
    handleFilter(field, value) {
      this.$store.dispatch(
        'setDetailCycleFilter',
        {
          field,
          value,
        },
      );
    },
  },
};
</script>

<style lang="scss">

.daily-trend-container {
  display: grid;
  height: 100%;
  width: 100%;
  max-width: 1705px;

  .dt-sub-container {
    display: grid;
    grid-auto-flow: row;
    gap: 1rem;

    .filter-container {
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;

      .dt-filter-option {
        display: grid;
        grid-auto-flow: column;
        justify-content: left;
        align-items: baseline;
        gap: 10px;
      }
    }

    .graphs-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }
  }

  .loading-container {
    display: grid;
    align-self: center;
  }
}
</style>
